import type { FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Card, Stack, Typography, Box } from '@mui/material';
import { ErrorOutline } from '@mui/icons-material';

interface PaymentBlockedByFailedChargeProps {
  sx?: object;
}

export const PaymentBlockedByFailedCharge: FC<
  PaymentBlockedByFailedChargeProps
> = ({ sx }) => {
  const { t } = useTranslation();

  return (
    <Card sx={{ p: 3, ...sx }}>
      <Stack spacing={3} alignItems="center">
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            backgroundColor: 'error.lighter',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <ErrorOutline sx={{ fontSize: 48, color: 'error.main' }} />
        </Box>

        <Typography variant="h5" align="center" gutterBottom>
          {t('mobile.family-member.payment-blocked-title')}
        </Typography>

        <Alert severity="error" sx={{ width: '100%' }}>
          <Typography variant="body1">
            {t('mobile.family-member.payment-blocked')}
          </Typography>
        </Alert>

        <Stack spacing={2} sx={{ width: '100%' }}>
          <Typography variant="body1" align="center">
            {t('mobile.family-member.payment-blocked-explanation')}
          </Typography>

          <Typography variant="body1" align="center" fontWeight="medium">
            {t('mobile.family-member.payment-blocked-contact-nursing-home')}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
};
